import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";

import { SiteLayout } from "@/components/site/SiteLayout";
import Home from "@/pages/Home";
import {
  CompanyPage,
  ProductsPage,
  ProjectsPage,
  CareersPage,
  InsightsPage,
  ContactPage,
  DetailPage,
  NotFoundPage,
} from "@/pages/SitePages";
import { Toaster } from "@/components/ui/toaster";

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <Routes>
          <Route element={<SiteLayout />}>
            <Route index element={<Home />} />
            <Route path="company" element={<CompanyPage />} />

            <Route path="products" element={<ProductsPage />} />

            <Route path="projects" element={<ProjectsPage />} />

            <Route path="careers" element={<CareersPage />} />

            <Route path="insights" element={<InsightsPage />} />
            <Route
              path="insights/:slug"
              element={<DetailPage sectionOverride="insights" />}
            />

            <Route path="contact" element={<ContactPage />} />
            <Route path="*" element={<NotFoundPage />} />
          </Route>
        </Routes>
        <Toaster />
      </BrowserRouter>
    </div>
  );
}

export default App;
